import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { getBalanceBarHeight } from "web_myplann/Finances/Helpers/getBalanceBarHeight";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

type Props = {
	label: string;
	amount: number;
	max: number;
	color: string;
};

export const BalanceBarColumn: FC<Props> = ({ label, amount, max, color }) => {
	const theme = useTheme();
	const { t } = useResource();
	const { height, minBarHeight } = theme.finances.barChart;

	return (
		<Stack flex={1} alignItems="center" gap={theme.spacingTokens.sm}>
			<Typography variant="hint">{label}</Typography>
			<Typography variant="bodyStrong" tabular>
				{moneyFormatter(amount, t(Resources.Common.CurrencySign))}
			</Typography>
			<Stack width="100%" height={height} justifyContent="flex-end">
				<Box
					height={getBalanceBarHeight({
						amount,
						max,
						height,
						minHeight: minBarHeight,
					})}
					bgcolor={color}
					borderRadius={`${theme.radii.sm} ${theme.radii.sm} 0 0`}
				/>
			</Stack>
		</Stack>
	);
};
